<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "administrator-system-notifications-index",
  mounted() {
    if (
      this.$route.name == "AdministratorNotifications" ||
      this.$route.name == "AdministratorFinalUserNotifications"
    ) {
      this.$router
        .push({
          name: "AdministratorSystemNotifications",
        })
        .catch(() => {});
    }
  },

  watch: {
    $route(val) {
      if (
        val.name == "AdministratorNotifications"
      ) {
        this.$router
          .push({
            name: "AdministratorSystemNotifications",
          })
          .catch(() => {});
      }
    },
  },
}
</script>